import React from "react";
import { Helmet } from "react-helmet-async";

// Per-route SEO metadata. Fixes duplicate title/description across pages.
export default function SEO({ title, description, path = "" }) {
  const fullTitle = title ? `${title} | RED.FLAG` : "RED.FLAG — Personal Finance Coach";
  const url = `https://finance-flag.com${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
